import React, { useState, useContext, useRef } from "react";
import { EntradasContext } from "../../context/EntradasContext";
import UploadFile from "../common/UploadFile";
import useProyecto from "../../hooks/useProyecto";

const BitacoraInput = ({ modifier }) => {
  const [tagging, setTagging] = useState(false);
  const [tagged, setTagged] = useState([]);
  const [value, setValue] = useState("");
  const [files, setFiles] = useState([]);
  const [uploadKey, setUploadKey] = useState(0);
  const uploadRef = useRef();

  const { usuarios } = useProyecto();

  const { clearAdjuntos } = useContext(EntradasContext);

  const handleChange = (evt) => {
    let value = evt.target.value;
    // if (tagging && evt.target.value !== "@" && evt.target.value !== "") return setQuery(value);
    // setTagging(false);
    setValue(value);
  };

  const tagUser = (Usuario) => {
    const { correo, nombre } = Usuario;
    if (tagged.find(usuario => usuario.correo === correo)) {
      setTagged(tagged.filter((user) => user.correo !== correo));
    } else {
      setTagged([...tagged, Usuario]);
      setValue(value + `${nombre} `);
    }
    setTagging(false);
  };

  const saveFiles = (files) => {
    setFiles(files);
  };

  const postMensaje = () => {
    value === "" ? modifier("", files, tagged) : modifier(value, files, tagged);
    clearAdjuntos();
    setValue("");
    setFiles([]);
    setUploadKey((k) => k + 1);
  };

  const handleKeyPress = (target) => {
    if (target.charCode === 13) {
      postMensaje();
    }
    if (target.charCode === 64) {
      setTagging(true);
    }
    if (target.charCode === 46 || target.charCode === 32 || target.charCode === 27) {
      setTagging(false);
    }
  };

  const renderUserList = () => {
    if (tagging) {
      // console.log(query);
      // const filtered = usuarios.filter(
      //   (user) =>
      //     String(user.nombre).includes(query) ||
      //     String(user.whatsapp).includes(query) ||
      //     String(user.correo).includes(query)
      // );
      return (
        <div className="py-2 bg-light w-100">
          <label className="bold">Etiquetar</label>
          {usuarios.map((user, index) => (
            <span
              key={user.idUsuario}
              className="d-block w-100 my-2 cursor-pointer"
              onClick={() => tagUser(user)}
            >
              {user.nombre} - {user.correo}
            </span>
          ))}
        </div>
      );
    }
  };

  return (
    <div
      id="bitacora-input"
      className="container-fluid card border p-3 shadow mb-0"
    >
      <UploadFile
        key={uploadKey}
        ref={uploadRef}
        modifier={saveFiles}
        multiple
        accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.zip"
        noTrigger
      />
      <div className="row align-items-center mx-0 position-relative">
        {renderUserList()}
        <div className="ps-0 col-9">
          <input
            type="text"
            value={value}
            maxLength={500}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            placeholder="Escribe un mensaje..."
            className="form-control bg-light py-2"
          />
        </div>
        <div className="col-1 px-0 d-flex justify-content-center">
          <button
            type="button"
            className="btn btn-link p-0 text-secondary"
            onClick={() => uploadRef.current?.open()}
          >
            <i className="fa fa-paperclip fa-lg" />
          </button>
        </div>
        <div className="col-2 ps-1 px-0">
          <button className="btn btn-primary w-100 px-0" onClick={postMensaje}>
            <i className="fas fa-paper-plane" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BitacoraInput;
